import { useDispatch, useSelector } from "react-redux";
import { downloadDisputeReport } from "../thunks/downloadReport";
import React from "react";
import { StoreType } from "../../../../core/store/reducers";
import { FetchStateType } from "../../../models";

export const useDisputeReportDownloader = () => {
  const fetchState = useSelector<StoreType, FetchStateType>(
    (s) => s.data.clearing.disputes.downloadReportFetchState
  );
  const dispatch = useDispatch();
  const download = React.useCallback(
    () => dispatch(downloadDisputeReport()),
    [dispatch]
  );

  return [download, fetchState] as [typeof download, typeof fetchState];
};
